// extracted by mini-css-extract-plugin
module.exports = {"holder":"Suggestions__holder--1dU","suggestions":"Suggestions__suggestions--32A"};